import { SystemFieldAndGrouping, SystemFieldGrouping } from "@common/components/filterPopover/FilterPopover.types.ts";
import { TableFields } from "@common/components/tableDisplayFields/TableFields.types.ts";
import { useSystemInputFieldsMapping } from "@common/hooks/useSelectableItemQueries.ts";
import { EntityFieldType } from "@common/entityField.types";
import { mapInputFieldTypeToContractFieldType } from "../../../contract/contractFieldTypeMapping.ts";
import { SystemColumn } from "./SystemDisplayFields.types.ts";

export default function useSystemDisplayFields(isEnabled: boolean = true) {
    const query = useSystemInputFieldsMapping(isEnabled);

    function getTableFieldsDictionary(): Record<string, SystemFieldAndGrouping> {
        const dictionary: Record<string, SystemFieldAndGrouping> = Object.fromEntries(
            Object.entries(query.data?.systemFieldsAndGroupings ?? []).map(([key, value]) => [key, value])
        );

        if (query.data) {
            query.data.customFieldsSelectableValues.forEach((x) => {
                dictionary[x.id] = { translation: x.name, column: undefined, grouping: SystemFieldGrouping.CustomFields };
            });
        }

        return dictionary;
    }

    function getTableFields(): Array<TableFields> {
        const dictionary = getTableFieldsDictionary();
        return Object.entries(dictionary).map(([id, obj]) => ({
            id,
            name: obj.translation,
            grouping: obj.grouping,
        }));
    }

    function getFilterIdToEnumMap(): Record<string, SystemColumn | undefined> {
        return Object.fromEntries(Object.entries(query.data?.systemFieldsAndGroupings ?? []).map(([key, value]) => [key, value.column]));
    }

    function getCustomFieldType(customFieldId: string): EntityFieldType | undefined {
        const customField = query.data?.customFieldsSelectableValues.find((x) => x.id === customFieldId);
        if (!customField) return undefined;
        return mapInputFieldTypeToContractFieldType(customField.type);
    }

    return {
        isLoading: query.isLoading,
        tableFields: getTableFields(),
        getTableFieldsDictionary,
        filterIdToEnumMap: getFilterIdToEnumMap(),
        getCustomFieldType,
    };
}
